import { useTranslation } from '@shared/core';
import { Flex, TextV2 } from '@withjoy/joykit';
import { Search } from '@withjoy/joykit/icons';
import React from 'react';

export const NoResultsFound: React.FC = () => {
  const { tq } = useTranslation('stationery');

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={[230, 400]}
      gap={[3, 5]}
    >
      <Search
        size={48}
        aria-hidden="true"
      />
      <TextV2
        typographyVariant={['hed4', 'hed6']}
        textAlign="center"
      >
        {tq`No results found.`}
      </TextV2>
      <TextV2
        typographyVariant={['body1', 'body4']}
        color="mono12"
        textAlign="center"
      >
        {tq`Look out for typos or try a different search.`}
      </TextV2>
    </Flex>
  );
};
